<div class="dropdown" dropdown>
  <button
    class="btn btn-link text-decoration-none dropdown-toggle d-flex align-items-center p-0"
    dropdownToggle
    type="button"
    id="user-menu-button"
    [attr.aria-expanded]="false"
    aria-haspopup="true">
    <ng-icon name="bootstrapPerson" class="me-1" size="1.25rem" />
    <span class="text-nowrap">{{ accountDisplayName }}</span>
    <ng-icon name="bootstrapChevronDown" class="ms-1" size="1rem" />
  </button>
  <ul
    class="dropdown-menu dropdown-menu-end"
    role="menu"
    aria-labelledby="user-menu-button"
    *dropdownMenu>
    <li role="menuitem">
      <a class="dropdown-item" routerLink="/profile/view">
        {{ 'COMPONENT.MAIN.MAIN.PROFILE' | translate }}
      </a>
    </li>
    <li><hr class="dropdown-divider" /></li>
    <li role="menuitem">
      <button type="button" class="dropdown-item" (click)="showPolicy()">
        {{ 'COMPONENT.MAIN.MAIN.POLICY' | translate }}
      </button>
    </li>
    <li role="menuitem">
      <button type="button" class="dropdown-item" (click)="showTerms()">
        {{ 'COMPONENT.MAIN.MAIN.TERMS' | translate }}
      </button>
    </li>
    <li><hr class="dropdown-divider" /></li>
    <li role="menuitem">
      <button type="button" class="dropdown-item" (click)="logout()">
        {{ 'COMPONENT.MAIN.MAIN.LOGOUT' | translate }}
      </button>
    </li>
  </ul>
</div>
